<template>
	<div class="form-group ">
		<label :for="hasId" class="text-capitalize" v-html="hasReq" :class="{'none': this.nolabel === true}"></label>
		<div class="cus-field"
			:class="{
				danger: displayValue === '' && req === true,
				success: displayValue !== '' && req === true,
				'no-custom': req === false,
			}"
		>
			<vue-timepicker 
				:id="hasId"
				:ref="hasId"
				format="HH:mm" 
				v-model="displayValue"
				hide-clear-button 
				:placeholder="option.placeholder" 
				fixed-dropdown-button
				close-on-complete
				hour-label="ชั่วโมง" 
				minute-label="นาที"
				manual-input
				auto-scroll
				drop-direction="auto"
				:disabled="cDisable"
				@close="close()"
				@open="open()"
			>
				<template v-slot:dropdownButton>
					<svg :class="{'disabled': cDisable !== false,}" xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" fill="#333333" class="bi bi-clock" viewBox="0 0 16 16">
						<path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
						<path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"/>
					</svg>
				</template>
			</vue-timepicker>
		</div>
	</div>
</template>

<script>
/* eslint-disable */
export default {
	props: ["title", "label", "placeholder", "value", "req", "type", "disable", "nolabel"],
	data() {
		return {
			option: {
				"locale": "en-GB",
				"isRTL": false,
				"hourCycle": "h24",
				"hour12": false,
				"hours": 0,
				"minutes": 0,
				"seconds": 0,
				"value": "00:00:00",
				"formatted": "00:00:00",
				"placeholder": 'Select Time',
			},
		}
	},
	computed: {
		hasReq() {
			if (this.label === null || typeof this.label === 'undefined') {
				return (this.hReq === false) ? this.title + ' : ' : this.title + ' : <span class="text-danger">*</span>';
			}else if(this.label === false){
				return '&emsp;'
			}else {
				return (this.hReq === false) ? this.label + ' : ' : this.label + ' : <span class="text-danger">*</span>';
			}
		},
		hReq() {
      		return (this.req === null || typeof this.req === 'undefined' || this.req === false) ? false : true;
		},
		hasId() {
			return (this.title === null || typeof this.title === 'undefined') ? '' : this.title.split(' ').join('-');
		},
		cDisable() {
			return (this.disable === null || typeof this.disable === 'undefined') ? false : this.disable;
		},
		displayValue: {
			get () {
				if (this.value == '' || this.value === null || this.value === undefined || typeof this.value === 'undefined') {
					if (document.getElementById(this.hasId)) {
						document.getElementById(this.hasId).value = ''
					}
					return '';
				}else{
					return this.value+':00';
				}
			},
			set (modifiedValue) {
				this.$emit('input', modifiedValue)
			}
		}
	},
	methods: {
		close() {
			this.$emit('close')
		},
		open() {
		},
		updateing () {
			this.$emit('input', this.mdata);
		},
		changeData () {
			this.$emit('changedata');
		},
	},
};
</script>

<style scoped>
	label.none{
		display: none;
	}
	*>>> .vue__time-picker{
		width: 100%;
		font-family: Sarabun, sans-serif;
		font-size: 1.25rem;
		font-weight: 600; 
	}
	* >>>.vue__time-picker input.display-time{
		color: #2d353c;
		height: calc(1.5em + 0.875rem + 2px);
		width: 100%;
		height: 2.3em;
		padding: 1.30rem 0.9rem;
		margin-left: 5px;
		border-radius: 0.18rem 0.6rem 0.6rem 0.18rem ;
		border: 1px solid #d5dbe0;
		font-size: 1.25rem;
		font-weight: 600; 
		font-family: Sarabun, sans-serif;
	}
	* >>>.cus-field.danger .vue__time-picker input.display-time:focus{
		border-color: #EE2524;
		-webkit-box-shadow: 0 0 0 0.2rem rgb(226 52 52 / 25%);
		box-shadow: 0 0 0 0.2rem rgb(226 52 52 / 25%);
	}
	* >>>.cus-field.success .vue__time-picker input.display-time:focus{
		border-color: #036453;
		-webkit-box-shadow: 0 0 0 0.2rem rgb(52 218 226 / 25%);
		box-shadow: 0 0 0 0.2rem rgb(52 218 226 / 25%);
	}
	* >>>.cus-field.no-custom .vue__time-picker input.display-time{
		border-radius: 0.6rem 0.6rem;
		margin-left: 0;
	}
	* >>>.vue__time-picker input.display-time:focus{
		border-color: #e0e5e8;
		-webkit-box-shadow: 0 0 0 0.2rem rgb(198 198 198 / 25%);
		box-shadow: 0 0 0 0.2rem rgb(198 198 198 / 25%);
	}
	* >>>.vue__time-picker input.display-time:focus::-webkit-input-placeholder{
		opacity: 0;
	}
	* >>>.vue__time-picker input.display-time::-webkit-input-placeholder {
		color: #2d353c !important;
		font-size: 1.25rem;
	}
	*>>>.vue__time-picker .controls img, .vue__time-picker .controls svg, .vue__time-picker .custom-icon img, .vue__time-picker .custom-icon svg {
		max-width: 25px;
	}
	*>>>.vue__time-picker .dropdown-btn.has-custom-btn svg.disabled{
		display: none;
	}
	*>>>.vue__time-picker .controls>* {
		padding: 0 7px;
	}
	* >>>.vue__time-picker input.display-time.disabled, .vue__time-picker input.display-time:disabled{
		background-color: #e9ecef;
	}
	*>>>.vue__time-picker .dropdown ul li:not([disabled]).active{
		background: #5e5e66 !important;
		color: #fff;
	}
</style>
